import PaymentsTransactions from './PaymentsTransactions.redux';

export default PaymentsTransactions;
